import {useEffect} from "react";
import {ProductDetails} from "../../../../components/products/product-details";

export function ViewProductPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <ProductDetails />;
}
